import { getHopinApiRoot } from '@hopin-team/config-hopin-constants';

import { fetchJSON } from '../../utils/fetch';

export async function loadTheme(
  eventSlug: string,
  callback: (brandColor: string | null, theme?: any) => void,
) {
  try {
    const branding = await fetchJSON(
      `${getHopinApiRoot('v2')}/public/events/${eventSlug}/branding`,
      {},
    );

    const color = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(branding.color)
      ? `#${branding.color}`
      : branding.color;
    const theme = parseThemeString(branding.theme);

    callback(color, theme);
  } catch (e) {
    callback(null, null);
  }
}

const parseThemeString = (theme: string) => {
  try {
    return JSON.parse(theme);
  } catch (_e) {
    return {};
  }
};
